// Classificação dos conectores do menu Integrações (H4, PO1-3617): tipo de
// sistema (um por conector) e capacidades ("o que troca", várias). Funções
// puras, usadas pelos filtros e pelas etiquetas dos cards. Os 6 cards fixos
// trazem `tipoSistema`/`capacidades` escritos em conectores.js; os cards do
// catálogo trazem a `categoria` e os `cap_*` da versão (H1/H3).
// PO1-3859 (épico PO1-3858): "gestao-entrega" = sistemas de gestão de entrega/canhoto/roteirização do
// embarcador (Comprovei, SimpliRoute), categoria nova do catálogo `Conector`.
export const TIPOS_SISTEMA = { erp: "ERP", fiscal: "Fiscal", captura: "Captura", coleta: "Coleta", "gestao-entrega": "Gestão de entrega" };

// PO1-3840: frete_pedido (SAP Business One, PO1-3835) sem rótulo aparecia cru no card e no painel.
export const CAPACIDADES = {
  pedido: "Pedido",
  frete_pedido: "Frete no pedido",
  nfe: "NF-e",
  cte: "CT-e",
  tracking: "Tracking",
  contas_pagar: "Contas a pagar",
  // PO1-3859: foto do canhoto / assinatura presa à NF (conectores de gestão de entrega).
  comprovante: "Comprovante",
};

// Atalho "Fiscal" = NF-e + CT-e.
export const ATALHO_FISCAL = ["nfe", "cte"];

// Direção do catálogo (minúscula, H1) → rótulo da tela (mesmos textos de DIRECOES).
export const DIRECOES_CATALOGO = { entrada: "Entrada", saida: "Saída", bidirecional: "Bidirecional" };

export function rotuloTipo(tipo) {
  return TIPOS_SISTEMA[tipo] || tipo || "";
}

export function rotuloCapacidade(cap) {
  return CAPACIDADES[cap] || cap || "";
}

export function alternar(lista, valor) {
  const atual = Array.isArray(lista) ? lista : [];
  return atual.indexOf(valor) === -1 ? [...atual, valor] : atual.filter((v) => v !== valor);
}

export function fiscalAtivo(capacidades) {
  const atual = Array.isArray(capacidades) ? capacidades : [];
  return ATALHO_FISCAL.every((c) => atual.indexOf(c) !== -1);
}

// Liga NF-e + CT-e de uma vez; se os dois já estão ligados, desliga os dois.
export function alternarFiscal(capacidades) {
  const atual = Array.isArray(capacidades) ? capacidades : [];
  if (fiscalAtivo(atual)) return atual.filter((c) => ATALHO_FISCAL.indexOf(c) === -1);
  return [...atual, ...ATALHO_FISCAL.filter((c) => atual.indexOf(c) === -1)];
}

// E entre as linhas de filtro (situação, tipo, capacidade); OU dentro de cada
// linha. `statusPorKey` é o status já calculado de cada card (por `key`).
export function filtrarConectores(lista, { status = "todas", tipos = [], capacidades = [] } = {}, statusPorKey = {}) {
  return (lista || []).filter((c) => {
    if (status !== "todas" && statusPorKey[c.key] !== status) return false;
    if (tipos.length && tipos.indexOf(c.tipoSistema) === -1) return false;
    if (capacidades.length && !(c.capacidades || []).some((cap) => capacidades.indexOf(cap) !== -1)) return false;
    return true;
  });
}

export function contarPorStatus(lista, statusPorKey) {
  const contagem = { todas: 0, ativa: 0, disponivel: 0, gerenciada: 0 };
  (lista || []).forEach((c) => {
    contagem.todas += 1;
    const s = statusPorKey[c.key];
    if (Object.prototype.hasOwnProperty.call(contagem, s)) contagem[s] += 1;
  });
  return contagem;
}

export function contarPorTipo(lista) {
  const contagem = {};
  Object.keys(TIPOS_SISTEMA).forEach((t) => { contagem[t] = 0; });
  (lista || []).forEach((c) => {
    if (Object.prototype.hasOwnProperty.call(contagem, c.tipoSistema)) contagem[c.tipoSistema] += 1;
  });
  return contagem;
}

export function contarPorCapacidade(lista) {
  const contagem = {};
  Object.keys(CAPACIDADES).forEach((k) => { contagem[k] = 0; });
  (lista || []).forEach((c) => {
    (c.capacidades || []).forEach((cap) => {
      if (Object.prototype.hasOwnProperty.call(contagem, cap)) contagem[cap] += 1;
    });
  });
  return contagem;
}
